import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/tada.gif';
const _hoisted_1 = { class: "success-page" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "hero-container" };
const _hoisted_4 = {
    key: 0,
    class: "policy-card-container"
};
const _hoisted_5 = { class: "features-container" };
const _hoisted_6 = {
    key: 0,
    class: "feature-item"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "anchor-bottom-no-nav" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useAssetConfig } from '@/composables/useAssetConfig';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AccountListItem from './elements/AccountListItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AssetSuccessPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getConfig } = useAssetConfig();
        const config = getConfig(route.query.type);
        const animateEmoji = ref(false);
        const showCard = ref(false);
        const featuresShown = ref(0);
        const account = ref(null);
        const id = computed(() => route.query.id);
        const allAnimationsComplete = computed(() => featuresShown.value >= config.successFeatures.length);
        const cardData = computed(() => account.value ? config.card(account.value, state.formatter) : null);
        function handleDone() {
            router.push('/money');
        }
        function startAnimations() {
            setTimeout(() => { animateEmoji.value = true; }, 100);
            setTimeout(() => { showCard.value = true; }, 2000);
            config.successFeatures.forEach((_, i) => {
                setTimeout(() => { featuresShown.value = i + 1; }, 2800 + i * 600);
            });
        }
        onMounted(() => {
            if (id.value) {
                config.getAccount(id.value, (result) => {
                    account.value = result ?? config.getStateAccount();
                    startAnimations();
                });
            }
            else {
                startAnimations();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(config).successTitle), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["emoji-container", { 'animate': animateEmoji.value, 'fade-out': showCard.value }])
                        }, _cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Celebration",
                                class: "party-emoji"
                            }, null, -1)
                        ]), 2),
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showCard.value && cardData.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(AccountListItem, {
                                            "provider-name": cardData.value.providerName,
                                            line1: cardData.value.line1,
                                            line2: cardData.value.line2,
                                            label: cardData.value.label,
                                            value: cardData.value.value,
                                            "avatar-url": cardData.value.avatarUrl
                                        }, null, 8, ["provider-name", "line1", "line2", "label", "value", "avatar-url"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).successFeatures, (feature, i) => {
                            return (_openBlock(), _createBlock(_Transition, {
                                name: "fade-slide",
                                key: i
                            }, {
                                default: _withCtx(() => [
                                    (featuresShown.value > i)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("img", {
                                                src: require(`../assets/${feature.icon}.svg`),
                                                alt: "",
                                                class: "feature-icon-img"
                                            }, null, 8, _hoisted_7),
                                            _createElementVNode("div", {
                                                class: "feature-text",
                                                innerHTML: feature.text
                                            }, null, 8, _hoisted_8)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(MGButton, {
                            text: "Done",
                            fullWidth: true,
                            disabled: !allAnimationsComplete.value,
                            onClick: handleDone
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
